var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"paragraph"},[_c('p',[_vm._v("An SAP RFC Connection is required to send data to REST services in the following features:")])]),_c('div',{staticClass:"ulist"},[_c('ul',[_c('li',[_c('p',[_vm._v("Events")])]),_c('li',[_c('p',[_vm._v("BW Extractors")])]),_c('li',[_c('p',[_vm._v("Table Service Extracts")])])])])])
}]

export { render, staticRenderFns }